import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AmountAggregationProcess  {
    _originalTypeClassName = "zERP.BO.AmountAggregationProcess";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AmountAggregationProcess.translate = translateService;
}
this.Entities = [];
this.Id = null;
this.Name = null;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Code:any;
Entities:any;
static setEntities = ($this, items) => {
                if (items == null) items = [];
                if ($this.Entities == null) $this.Entities = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Entities.length > 0) {
                    Domain.AmountAggregationProcess.removeEntities($this, $this.Entities[0]);
                }

                Domain.AmountAggregationProcess.addManyEntities($this, copyItems);
            }
static addManyEntities = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AmountAggregationProcess.addEntities($this, items[i]);
                }
            }
static addEntities = ($this, item) => {
                if ($this.Entities == null) $this.Entities = [];
                if (item == null || $this.Entities.indexOf(item) > -1) return;
                $this.Entities.push(item);
}
static addRangeEntities = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AmountAggregationProcess.addEntities($this, item));
            }
static removeEntities = ($this, item) => {
                if ($this == null || $this.Entities == null || $this.Entities.indexOf(item) === -1) return;
                var _index = $this.Entities.indexOf(item);
                $this.Entities.splice(_index, 1);
}
static clearEntities = ($this) => { $this.Entities = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}